import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/trackvideo/',
    name: 'Track Video',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve() {
        let url = `${window.location.protocol}//${window.location.host}/trackvideo-2/`
        if (
          store.getters['identity/hasAccessAll']([
            'b3h-new-trackvision-menu:read',
            'b3j-trackvision-live-streaming:read',
          ])
        ) {
          url = `${window.location.protocol}//${window.location.host}/live-streaming/`
        }
        window.location.href = url
      },
    },
  },
  {
    path: '/trackvideo-2/',
    name: 'Track Video V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b3h-new-trackvision-menu:read'])) {
          next({ name: 'Liveview' })
          return
        }
        if (
          store.getters['identity/hasAccessAll']([
            'b3d-pelacakan-video-new:read',
            'vehicle_video_trackers:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackvideo-2/'),
  },
]
